import React, { useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  Accordion,
} from "react-bootstrap";
import AccordionCard from "./AccordionCard";
import Badge from "react-bootstrap/Badge";
import {useTranslation} from "react-i18next";


const DetailProperty = ({ property }) => {
  const { t } = useTranslation('common');

  const [activeKeys, setActiveKeys] = useState(["0"]);

  const handleSelect = (eventKey) => {
    setActiveKeys((prev) =>
      prev.includes(eventKey)
        ? prev.filter((key) => key !== eventKey)
        : [...prev, eventKey]
    );
  };

  const isKeyActive = (eventKey) => activeKeys.includes(eventKey);

  return (
    <>
    <Accordion
      defaultActiveKey="0"
      activeKey={activeKeys}
      onSelect={handleSelect}
    >
      <AccordionCard eventKey="0">
        <Card.Body>
          <div className="d-flex align-items-center justify-content-between">
            <h3 className="h6 card-title pt-1 mb-0">{t("Caractéristiques")}</h3>
            <i
              className={`fi-chevron-${
                isKeyActive("0") ? "up" : "down"
              } fs-base text-muted me-1`}
            ></i>
          </div>
        </Card.Body>
        <Accordion.Collapse eventKey="0">
          <Card.Body className="mt-n1 pt-0">
            <Card className="border-opacity-10">
              <CardBody>
                <div className="d-flex align-items-center mb-2">
                  <i className="fi-briefcase text-primary me-2 mb-0"></i>
                  <h3 className="h6 card-title pt-1 mb-0">{t("Pièces")}</h3>
                </div>
                <div
                  className="d-grid gap-3"
                  style={{ gridTemplateColumns: "repeat(2, 1fr)" }}
                >
                  {parseInt(property?.nombre_pieces) > 0 && (<div className="d-flex flex-column align-items-left">
                    <span>{t("Nb. total de pièces")}</span>
                    <span className="fw-semibold text-primary">
                      {property?.nombre_pieces ?? 0}
                    </span>
                  </div>)}

                  {parseInt(property?.nb_chambre) > 0 && (<div className="d-flex flex-column align-items-left">
                    <span>{t("Nb. de chambres simples")}</span>
                    <span className="fw-semibold text-primary">
                      {property?.nb_chambre ?? 0}
                    </span>
                  </div>)}
                  {parseInt(property?.nb_chambre_sdb) > 0 && (<div className="d-flex flex-column align-items-left">
                    <span>{t("Nb. de chambres avec salle de bain")}</span>
                    <span className="fw-semibold text-primary">
                      {property?.nb_chambre_sdb ?? 0}
                    </span>
                  </div>)}
                  {parseInt(property?.nb_salle_de_bain) > 0 && (<div className="d-flex flex-column align-items-left">
                    <span>{t("Nb. de salles de bains")}</span>
                    <span className="fw-semibold text-primary">
                      {property?.nb_salle_de_bain ?? 0}
                    </span>
                  </div>)}
                  {parseInt(property?.nb_salle_eau) > 0 && (<div className="d-flex flex-column align-items-left">
                    <span>{t("Nb. de salles d'eau")}</span>
                    <span className="fw-semibold text-primary">
                      {property?.nb_salle_eau ?? 0}
                    </span>
                  </div>)}
                  {parseInt(property?.nb_salon) > 0 && (<div className="d-flex flex-column align-items-left">
                    <span>{t("Nb. de salons")}</span>
                    <span className="fw-semibold text-primary">
                      {property?.nb_salon ?? 0}
                    </span>
                  </div>)}
                  {parseInt(property?.nb_sejour) > 0 && (<div className="d-flex flex-column align-items-left">
                    <span>{t("Nb. de séjours")}</span>
                    <span className="fw-semibold text-primary">
                      {property?.nb_sejour ?? 0}
                    </span>
                  </div>)}
                </div>
              </CardBody>
            </Card>

            <Card className="border-opacity-10 mt-3">
              <CardBody>
                <div className="d-flex align-items-center mb-2">
                  <i className="fi-briefcase text-primary me-2"></i>
                  <h3 className="h6 card-title pt-1 mb-0">{t("Surfaces")}</h3>
                </div>
                <div
                  className="d-grid gap-3"
                  style={{ gridTemplateColumns: "repeat(2, 1fr)" }}
                >
                  {parseInt(property?.surface_habitable) > 0 && (
                  <div className="d-flex flex-column align-items-left">
                    <span>{t("Surface habitable (m²)")}</span>
                    <span className="fw-semibold text-primary">
                      {property?.surface_habitable ?? 0} m²
                    </span>
                  </div>)}
                  {parseInt(property?.surface_terrain) > 0 && (<div className="d-flex flex-column align-items-left">
                    <span>{t("Surface terrain (m²)")}</span>
                    <span className="fw-semibold text-primary">
                      {property?.surface_terrain ?? 0} m²
                    </span>
                  </div>)}
                </div>
              </CardBody>
            </Card>
            {parseInt(property?.nbr_parking) > 0 && (
            <Card className="mt-3">
              <CardBody>
                <div className="d-flex align-items-center mb-2">
                  <i className="fi-parking text-primary me-2"></i>
                  <h3 className="h6 card-title pt-1 mb-0">{t("Parking")}</h3>
                </div>
                <div
                  className="d-grid gap-3"
                  style={{ gridTemplateColumns: "repeat(2, 1fr)" }}
                >
                  {parseInt(property?.nbr_parking) > 0 && (<div className="d-flex flex-column align-items-left">
                    <span>{t("Nb. d'emplacements parking")}</span>
                    <span className="fw-semibold text-primary">
                      {property?.nbr_parking ?? 0}
                    </span>
                  </div>)}
                </div>
              </CardBody>
            </Card>)}
          </Card.Body>
        </Accordion.Collapse>
      </AccordionCard>
    </Accordion>
    <Accordion
  defaultActiveKey="0"
  activeKey={activeKeys}
  onSelect={handleSelect}
>
{property?.sous_prestations.length > 0 &&
  <AccordionCard eventKey="1">
    <Card.Body>
      <div className="d-flex align-items-center justify-content-between">
        <h3 className="h6 card-title pt-1 mb-0">{t("Prestations")}</h3>
        <i
          className={`fi-chevron-${
            isKeyActive("1") ? "up" : "down"
          } fs-base text-muted me-1`}
        ></i>
      </div>
    </Card.Body>
    <Accordion.Collapse eventKey="1">
      <Card.Body className="mt-n1 pt-0">
        {/* Confort */}
        {property?.sous_prestations?.filter(sp =>
          property.prestations.some(p => p.id === sp && p.prestation_id === 1)
        ).length > 0 && (
          <Card className="border-opacity-10 mb-3">
            <CardBody>
              <div className="d-flex align-items-center mb-2">
                <i className="fi-star text-primary me-2"></i>
                <h3 className="h6 card-title pt-1 mb-0">{t("Confort")}</h3>
              </div>
              <div className="d-flex flex-wrap gap-2">
                {property.prestations
                  .filter(p => p.prestation_id === 1 && property.sous_prestations.includes(p.id))
                  .map((prestation, index) => (
                    <Badge key={index} bg="secondary" className="p-2">
                      {t(prestation.nom_sous_prestation)}
                    </Badge>
                  ))
                }
              </div>
            </CardBody>
          </Card>
        )}

        {/* Chauffage */}
        {property?.sous_prestations?.filter(sp =>
          property.prestations.some(p => p.id === sp && p.prestation_id === 2)
        ).length > 0 && (
          <Card className="border-opacity-10 mb-3">
            <CardBody>
              <div className="d-flex align-items-center mb-2">
                <i className="fi-thermometer text-primary me-2"></i>
                <h3 className="h6 card-title pt-1 mb-0">{t("Type de chauffage")}</h3>
              </div>
              <div className="d-flex flex-wrap gap-2">
                {property.prestations
                  .filter(p => p.prestation_id === 2 && property.sous_prestations.includes(p.id))
                  .map((prestation, index) => (
                    <Badge key={index} bg="secondary" className="p-2">
                      {t(prestation.nom_sous_prestation)}
                    </Badge>
                  ))
                }
              </div>
            </CardBody>
          </Card>
        )}

        {/* Source d'énergie */}
        {property?.sous_prestations?.filter(sp =>
          property.prestations.some(p => p.id === sp && p.prestation_id === 3)
        ).length > 0 && (
          <Card className="border-opacity-10 mb-3">
            <CardBody>
              <div className="d-flex align-items-center mb-2">
                <i className="fi-flame text-primary me-2"></i>
                <h3 className="h6 card-title pt-1 mb-0">{t("Source d'énergie")}</h3>
              </div>
              <div className="d-flex flex-wrap gap-2">
                {property.prestations
                  .filter(p => p.prestation_id === 3 && property.sous_prestations.includes(p.id))
                  .map((prestation, index) => (
                    <Badge key={index} bg="secondary" className="p-2">
                      {t(prestation.nom_sous_prestation)}
                    </Badge>
                  ))
                }
              </div>
            </CardBody>
          </Card>
        )}

        {/* Distribution */}
        {property?.sous_prestations?.filter(sp =>
          property.prestations.some(p => p.id === sp && p.prestation_id === 4)
        ).length > 0 && (
          <Card className="border-opacity-10 mb-3">
            <CardBody>
              <div className="d-flex align-items-center mb-2">
                <i className="fi-layers text-primary me-2"></i>
                <h3 className="h6 card-title pt-1 mb-0">{t("Distribution")}</h3>
              </div>
              <div className="d-flex flex-wrap gap-2">
                {property.prestations
                  .filter(p => p.prestation_id === 4 && property.sous_prestations.includes(p.id))
                  .map((prestation, index) => (
                    <Badge key={index} bg="secondary" className="p-2">
                      {t(prestation.nom_sous_prestation)}
                    </Badge>
                  ))
                }
              </div>
            </CardBody>
          </Card>
        )}

        {/* Sécurité */}
        {property?.sous_prestations?.filter(sp =>
          property.prestations.some(p => p.id === sp && p.prestation_id === 5)
        ).length > 0 && (
          <Card className="border-opacity-10">
            <CardBody>
              <div className="d-flex align-items-center mb-2">
                <i className="fi-lock text-primary me-2"></i>
                <h3 className="h6 card-title pt-1 mb-0">{t("Sécurité")}</h3>
              </div>
              <div className="d-flex flex-wrap gap-2">
                {property.prestations
                  .filter(p => p.prestation_id === 5 && property.sous_prestations.includes(p.id))
                  .map((prestation, index) => (
                    <Badge key={index} bg="secondary" className="p-2">
                      {t(prestation.nom_sous_prestation)}
                    </Badge>
                  ))
                }
              </div>
            </CardBody>
          </Card>
        )}
      </Card.Body>
    </Accordion.Collapse>
  </AccordionCard>}
</Accordion>

    </>
  );
};

export default DetailProperty;
